import React, { Component, Fragment } from 'react';
import { Alert, Button, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, withApollo } from 'react-apollo';

export const archiveCustomerMutation = gql`
  mutation archiveCustomer($id: Int!) {
    archiveCustomer(id: $id) {
      id
    }
  }
`;

export class CustomerArchive extends Component {
  state = {
    isOpen: false,
    submitting: false,
    error: null
  };

  setError = error => {
    this.setState({ error });
  };

  setSubmitting = submitting => {
    this.setState({ submitting });
  };

  onToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  renderNopeModalInner = () => {
    // You can't delete an customer if it has orders
    const { orders, name } = this.props.customer;

    return (
      <Fragment>
        <ModalHeader toggle={this.onToggle}>Cannot archive</ModalHeader>
        <ModalBody>
          <p className="mb3">
            You can't archive <em>{name}</em> as it already has recorded orders:
          </p>
          <ul className="mb0">
            {orders.map(({ order }) => (
              <li key={order.id}>{order.reference}</li>
            ))}
          </ul>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.onToggle}>
            Ok
          </Button>{' '}
        </ModalFooter>
      </Fragment>
    );
  };

  renderConfirmationModalInner = () => {
    const { client, customer, history } = this.props;
    const { name } = customer;
    const { submitting, error } = this.state;
    return (
      <Mutation mutation={archiveCustomerMutation}>
        {archiveCustomer => (
          <Fragment>
            <ModalHeader toggle={this.onToggle}>Are you sure?</ModalHeader>
            <ModalBody>
              {error && <Alert color="danger">{error}</Alert>}
              Are you sure you want to archive the customer <em>{name}</em>?
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.onToggle}>
                Cancel
              </Button>{' '}
              <Button
                disabled={submitting}
                color="primary"
                onClick={async () => {
                  try {
                    this.setSubmitting(true);
                    await archiveCustomer({
                      variables: {
                        id: customer.id
                      }
                    });
                    // Clear cache
                    client.resetStore();
                    history.push(`/customers?archived=${name}`);
                  } catch (err) {
                    console.log(err);
                    this.setSubmitting(false);
                    this.setError('An unknown error occured');
                  }
                }}
              >
                Archive
              </Button>
            </ModalFooter>
          </Fragment>
        )}
      </Mutation>
    );
  };

  render() {
    const { className, customer } = this.props;

    if (!customer) {
      // In some cases where customer comes though asyncronously, there is a chance that the customer
      // does not exist yet. If that is the case, don't render anything
      return null;
    }

    return (
      <Fragment>
        <Button className={className} color="danger" outline onClick={this.onToggle}>
          Archive
        </Button>
        <Modal isOpen={this.state.isOpen} toggle={this.onToggle}>
          {this.renderConfirmationModalInner()}
          {/* {Note - do the below when orders are in kplace} */}
          {/* {customer.orders.length ? this.renderNopeModalInner() : this.renderConfirmationModalInner()} */}
        </Modal>
      </Fragment>
    );
  }
}

export default withRouter(withApollo(CustomerArchive));



// WEBPACK FOOTER //
// ./src/containers/customerArchive/customerArchive.jsx